<template>
  <div class="blog-pagination">
    <!-- First Page -->
    <a
      :href="getUrl(1)"
      :aria-label="$i18n('blog.first-page')"
      :class="['blog-pagination__static-button', { disabled: currentPage == 1 }]"
    >
      <IconArrow />
      <span>{{ $i18n('blog.first-page') }}</span>
    </a>
    <!-- ./First Page -->

    <!-- Pagination Buttons -->
    <div class="button-wrapper">
      <a
        v-for="page in parseInt(totalPage)"
        :key="`page_${page}`"
        :href="getUrl(page)"
        :aria-label="`page_${page}`"
        :class="['button-wrapper__button', { 'button-wrapper__button--active': page === currentPage }]"
      >
        {{ page }}
      </a>
    </div>
    <!-- ./Pagination Buttons -->

    <!-- Last Page -->
    <a
      :href="getUrl(totalPage)"
      :aria-label="$i18n('blog.last-page')"
      :class="['blog-pagination__static-button', { disabled: currentPage == totalPage }]"
    >
      <span>{{ $i18n('blog.last-page') }}</span>
      <IconArrow class="transform rotate-180" />
    </a>
    <!-- ./Last Page -->
  </div>
</template>
<script>
import IconArrow from '~/components/icons/IconArrow.vue';

export default {
  name: 'Pagination',
  components: {
    IconArrow,
  },
  props: {
    routePath: {
      type: String,
      default: null,
    },
    currentPage: {
      type: [String, Number],
      default: 1,
    },
    totalPage: {
      type: [String, Number],
      default: 1,
    },
  },
  methods: {
    getUrl(pageNumber = 1) {
      let url = `${this.routePath}/`;

      if (pageNumber > 1) {
        url += `?page=${pageNumber}`;
      }

      return url;
    },
  },
};
</script>

<style lang="scss">
.blog-pagination {
  @apply md:container px-5 lg:px-0 flex items-center justify-between py-4 border-y border-gray-200 mb-[80px];

  &__static-button {
    @apply duration-200 flex items-center space-x-4 rounded;

    &:hover:not(.disabled) {
      @apply text-blue-600;
    }

    &.disabled {
      @apply text-gray-400 pointer-events-none;
    }
  }

  .button-wrapper {
    @apply space-x-4 flex;

    &__button {
      @apply transition ease-in-out duration-300 w-8 h-8 font-sans font-bold rounded-lg text-gray-400 text-center leading-[33px];

      &:not(.button-wrapper__button--active):hover {
        @apply text-blue-600 bg-gray-200;
      }

      &--active {
        @apply bg-blue-600 text-white hover:bg-blue-700;
      }
    }
  }
}
</style>
